import React, { useEffect } from "react";
import MasterLayout from "../../../masterLayout/MasterLayout";
import FormPlatillos from "../../../components/menu/platillos/FormPlatillos";
import Loader from "../../../components/Loader";
import { useParams, useNavigate } from 'react-router-dom';
import usePlatillosStore from "../../../store/platilloStore";

const DetallePlatillo = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const { isLoading, actualizarId, iniciar, setNavigate, limpiar } = usePlatillosStore();

  useEffect(() => {
    limpiar();
    setNavigate(navigate);
    actualizarId(id);
    iniciar();
  }, [id]);

  return (
    <>
      <MasterLayout>
        { (isLoading.cargarSucursalCategoria || isLoading.cargarPlatillo) ? 
          <Loader /> : 
          <FormPlatillos/>
        }
      </MasterLayout>
    </>
  );
};

export default DetallePlatillo;
